<template>
  <b-popover
    v-if="targetId"
    ref="popover"
    :target="`mod-popover-${targetId}`"
    triggers="hover"
    :placement="placement"
    :html="true"
    custom-class="popover-lg"
  >
    <div v-for="(mod, index) in moderators" :key="mod.id" :class="{ 'mb-3': index < moderators.length - 1 }">
      <div class="avatar avatar-sm">
        <img :src="mod.image_url || DefaultEventImg" alt="Avatar" class="avatar-img rounded-circle" />
      </div>
      <strong class="ml-2">{{ mod.name }}</strong>
    </div>
  </b-popover>
</template>

<script>
import DefaultAvatar from '@/assets/images/logos/logo_icon.png';

export default {
  name: 'ModeratorsListPopover',
  components: {},

  props: {
    moderators: { type: Array, default: () => [] },
    targetId: { required: true },
    placement: { type: String, default: 'right' },
  },

  data() {
    return {
      DefaultAvatar,
    };
  },

  computed: {
    breadcrumb() {
      return [
        { text: this.$t('home'), to: this.routes.home },
        { text: 'Sample Page', active: true },
      ];
    },
  },

  methods: {},

  async mounted() {},
};
</script>
